import clickOutside from "src/directives/click-outside.js";
import focus from "src/directives/focus.js";
import stickyTableHeader from "src/directives/sticky-theader.js";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
    install(Vue) {
        Vue.directive("click-outside", clickOutside);
        Vue.directive("focus", focus);
        Vue.directive("sticky-theader", stickyTableHeader);
    },
};

export default GlobalDirectives;
